import { render, staticRenderFns } from "./xbtjzbhxr.vue?vue&type=template&id=48031840&scoped=true&"
import script from "./xbtjzbhxr.vue?vue&type=script&lang=js&"
export * from "./xbtjzbhxr.vue?vue&type=script&lang=js&"
import style0 from "./xbtjzbhxr.vue?vue&type=style&index=0&id=48031840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48031840",
  null
  
)

export default component.exports